/**
 * JS 기본 Error 또는 확장 Error 여부
 */
export function isError(value: unknown): value is Error {
  if (typeof value !== 'object' || value === null) return false;

  const obj = value as { name?: unknown; message?: unknown };
  return typeof obj.name === 'string' && typeof obj.message === 'string';
}
